<template>
  <div class="row">

    <div class="virtual__assistant__container">
        <span class="title-page" v-text="translations.index.title_virtual_assistant"></span>
        <span v-if="processing" style="font-style: italic;font-weight: 100;padding-left: 10px; padding-right: 10px; color: #9a9a9a;flex:1" v-text="translations.index.label_processing"></span>
        <button class="btn btnBlueCreate btnCadastro" data-toggle="modal" v-on:click="openCreateModal()" :disabled="processing || this.va_list.length >= this.limit" data-ba-i="open-create">
          <i class="fa fa-plus fa-md" aria-hidden="true"></i>
          <span style="margin-left: 3px;margin-right: 3px" v-text="translations.index.create_virtual_assistant"></span>
        </button>
    </div>

    <div class="container">
    <div class="row">
        <div class="col-sm-12 col-md-3">
          <select class="form-control" v-on:change="reorderSelectChange($event)" data-ba-i="reorder-list">
            <option value=""><span v-html="translations.index.label_order_by"></span></option>
            <option value="name_asc"><span v-html="translations.index.label_order_name_asc"></span> </option>
            <option value="name_desc"><span v-html="translations.index.label_order_name_desc"></span></option>
            <option value="created_asc"><span v-html="translations.index.label_order_date_asc"></span></option>
            <option value="created_desc"><span v-html="translations.index.label_order_date_desc"></span></option>
            <option value="status_asc"><span v-html="translations.index.label_order_status_asc"></span></option>
            <option value="status_desc"><span v-html="translations.index.label_order_status_desc"></span></option>
          </select>
        </div>
    </div>
    </div>
    <div class="table-responsive card">
      <div class="container">
      </div>
      <div>
        <table class="table">
          <thead>
            <tr>
              <th class="text-center">
                <span v-html="translations.index.name"></span>
              </th>
              <th class="text-center">
                <span v-html="translations.index.created_at"></span>
              </th>
              <th class="text-center">
                <span v-html="translations.index.key"></span>
              </th>
              <th class="text-center">
                <span v-html="translations.index.allowed_tools"></span>
              </th>
              <th class="text-center">
                <span v-html="translations.index.enable_disable"></span>
              </th>
              <th class="text-center">
                  <!-- Show log -->
              </th>
              <th class="text-center">
                  <!-- Edit -->
              </th>
              <th class="text-center">
                  <!-- Delete -->
              </th>
            </tr>
          </thead>
          <tbody v-if="this.list.length > 0">
            <tr v-for="(va, index) in this.list" v-bind:class="[va.is_active == 1 ? 'tb_row' : 'disabled tb_row']">
              <td class="text-center">{{ va.first_name }}</td>
              <td class="td-sm text-center">{{ va.created_at }}</td>
              <td class="td-key text-center" :id="['key_' + index]">{{ va.access_key }}
                <button type="button" :data-clipboard-target="['#key_' + index]" class="btn btn-default btn-md copy btn-copy" v-on:click="clipboard()" :disabled="!va.is_active" data-ba-i="copy-token">
                  <i class="fa fa-copy fa-lg"></i>
                </button>
              </td>
              <td class="td-md">
                <div class="text-center edit-tools" >
                  <a href="javascript:void(0);" v-on:click="editTools(va, index)"> <span v-text="translations.index.label_edit_tools" data-ba-i="edit-tools"></span></a>
                  <a href="javascript:void(0);" data-toggle="collapse" :data-target="['#collapse_' + index]" aria-expanded="true" :aria-controls="['collapse_' + index]" data-ba-i="show-tools">
                    <span v-bind:class="'show-hide ' + [va.tools.length > 0 ? '' : 'now-hide']"  v-text="translations.index.label_show"></span>
                  </a>
                </div>

                <!-- Ferramentas do VA -->
                <div class="tools collapse" :id="['collapse_' + index]">
                  <div v-for="t in va.tools" class="tools">
                      <!-- Nível 1 -->
                      <strong class="tier-1"><span v-html="t.title"></span></strong>

                      <!-- Nível 2 -->
                      <div v-for="t2 in t.children">
                          <strong class="tier-2"><small><span v-html="t2.title"></span></small></strong>

                          <!-- Nível 3 -->
                          <div v-for="t3 in t2.children">
                            <small class="tier-3"><span v-html="t3.title"></span></small>
                          </div>
                      </div>
                  </div>
                </div>
              </td>
              <td class="text-center">

                <label class="toggle" >
                  <input class="toggle-checkbox" type="checkbox" v-model="va.is_active" v-on:click="changeStatus(va)" :disabled="processing" data-ba-i="change-status">
                  <div class="toggle-switch"></div>
                </label>
              </td>
                <td class="text-center">
                 <a :href="va.log_url" target="_blank" data-ba-i="access-logs"><i  v-bind:class="'fa fa-list fa-lg ' + [processing ? 'disabled-icon' : 'action-icon']"></i></a>
               </td>
               <td class="text-center">
                 <div  v-on:click="openEditModal(va)" data-ba-i="edit-virtual-assistant"><i v-bind:class="'fa fa-pencil-square-o fa-lg ' + [processing ? 'disabled-icon' : 'action-icon']"></i></div>
               </td>
                <td class="text-center">
                 <div v-on:click="openDeleteModal(va, index)" data-ba-i="delete-virtual-assistant" ><i  v-bind:class="'fa fa-trash-o fa-lg ' + [processing ? 'disabled-icon' : 'action-icon']"></i></div>
               </td>
            </tr>
          </tbody>
          <tbody v-else>
              <tr>
                <td colspan="5" class="text-center">
                  <span v-html="translations.index.none_registered_va"></span>
                </td>
              </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div>

      <!-- MODAL DO DELETE -->
      <div class="modal fade"  id="ModalDelete" tabindex="-1" role="dialog" aria-labelledby="ModalDelete" aria-hidden="true">
        <div class="modal-dialog" style="max-width: 500px;">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="titleModal">
                <span v-text="translations.index.atencao"></span>
              </h5>
            </div>
            <div class="modal-body">
             <span v-html="translations.index.label_delete_va"></span>
            </div>
            <div class="modal-footer">
              <div class="col-md-12">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" data-ba-i="cancel-delete">
                  <span v-text="translations.index.button_cancelar"></span>
                </button>
                <button type="button" class="btn btn-danger" v-on:click="deleteVA()" data-ba-i="confirm-delete">
                  <span v-text="translations.index.general_label_delete"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- MODAL DO SAVE -->
      <div class="modal fade"  id="ModalSave" tabindex="-1" role="dialog" aria-labelledby="ModalSave" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="titleModal">
                <span v-if="this.virtualAssistant == null" v-text="translations.index.va_create_title"></span>
                <span v-else v-text="translations.index.va_edit_title"></span>
              </h5>
            </div>
            <div class="modal-body">
              <input v-model="va_name" class="form-control" v-bind:placeholder="this.translations.index.va_create_placeholder">
            </div>
            <div class="modal-footer">
              <div class="col-md-12">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" :data-ba-i="this.virtualAssistant == null ? 'cancel-create' : 'cancel-edit'">
                  <span v-text="translations.index.button_cancelar"></span>
                </button>
                <button v-if="this.virtualAssistant == null" type="button" class="btn btnCadastro" v-on:click="save(null)" :data-ba-i="this.virtualAssistant == null ? 'save-create' : 'save-edit'">
                  <span v-text="translations.index.button_salvar"></span>
                </button>
                 <button v-else type="button" class="btn btnCadastro" v-on:click="save(1)" :data-ba-i="this.virtualAssistant == null ? 'save-create' : 'save-edit'">
                  <span v-text="translations.index.button_salvar" ></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- MODAL DO  TOOLS -->
      <div class="modal fade" id="ModalTools" tabindex="-1" role="dialog" aria-labelledby="ModalTools" aria-hidden="true">
        <div class="modal-dialog modal-dialog-tools">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="titleModal">
                <span v-text="translations.index.label_tools_title"></span>
              </h5>
            </div>
            <div class="modal-body-tools">
              <tools :nodes="this.tools"  :translations="this.translations"></tools>
            </div>
            <div class="modal-footer">


              <div class="col-md-0">
                <button type="button" class="btn btn-secondary btnFooter" data-dismiss="modal" data-ba-i="cancel-edit-tools">
                  <span v-text="translations.index.button_cancelar"></span>
                </button>
                <button type="button" class="btn btnCadastro btnFooter" v-on:click="saveTools()">
                  <span v-text="translations.index.button_salvar" data-ba-i="save-edit-tools"></span>
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
// import merge from 'lodash-es/merge';
import qs from "qs";
import Tools from './tools.vue';
import {Encryption} from '../../../../../public_html/internacional/public/scripts/front-encryption/encrypt-vue.js';

export default {
  name: "virtual-assistant",
  props: ["user", "va_list", "translations", "tool_list", 'encryption_key'],
  components: {Tools},
  data() {
    return {
      va_name: "",
      list: [],
      virtualAssistant: null,
      tools: [],
      idx: null,
      base_url: null,
      processing: false,
      reorder_key: "",
      limit: 0,
      encryption: null,
    };
  },
  mounted() {
    this.list = this.va_list;
    this.base_url = window.location.pathname.replace(/\/$/g, '');
    this.limit = typeof this.user.office_configuracoes != 'undefined' && this.user.office_configuracoes !== null && this.user.office_configuracoes.virtual_assistant_limit ? Number(this.user.office_configuracoes.virtual_assistant_limit) : Number.MAX_SAFE_INTEGER;
    this.encryption = new Encryption();
  },
  methods: {
    // configure selected tools by the VA configuration
    configureVATools:function (tools) {
      let t = [];
      for(let i = 0; i< this.virtualAssistant.tools.length; i++){
        t.push(this.virtualAssistant.tools[i].id);

        for (let l = 0; l < this.virtualAssistant.tools[i].children.length; l++) {
          t.push(this.virtualAssistant.tools[i].children[l].id);

          for (let k = 0; k < this.virtualAssistant.tools[i].children[l].children.length; k++) {
            t.push(this.virtualAssistant.tools[i].children[l].children[k].id);
          }
        }
      }

      for (let i = 0; i < tools.length; i++) {
          tools[i].selected = false;
          for (let j = 0; j < t.length; j++) {
          if (t[j] == tools[i].tool.id) {
              tools[i].selected = true;
            }
         }

        if(tools[i].children.length > 0){
          this.configureVATools(tools[i].children);
        }
      }
      return tools;
    },
    //Btn action to edit tools
    editTools:function(va, idx){
      if(va.is_active){
        this.idx = idx;
        this.virtualAssistant = va;
        this.tools = this.configureVATools(this.tool_list);
        $("#ModalTools").modal("show");
      }else{
        alertMsg("error", this.translations.index.not_allowed_to_edit_va_tools)
      }
    },

    //Btn action to save VA tools
    saveTools: function() {
      let selectedTools = [];
      let group_tools = this.getSelectedTools(this.tools);

      for (let i = 0; i < group_tools.length; i++) {
        selectedTools.push(group_tools[i].id)
      }

       const url = `${this.base_url}/tools`;
        axios
          .post(url, qs.stringify({ id_va: this.encryption.encrypt(this.virtualAssistant.id, this.encryption_key), tools: selectedTools }))
          .then(response => this.saveToolsResponse(response.data, group_tools))

    },

    //Return all selected tools on configuartion
    getSelectedTools: function(tools){
      let selectedTools = [];
      for (let j = 0; j < tools.length; j++) {
        if (tools[j].selected) {
          selectedTools.push(tools[j].tool);
          }
          if(tools[j].children.length > 0){
            let sl = this.getSelectedTools(tools[j].children)
             for (let i = 0; i < sl.length; i++) {
              selectedTools.push(sl[i])
            }
        }
      }
      return selectedTools;
    },

    //Deal with save tools response
    saveToolsResponse: function(response, tools){
      if(response.success){
        $("#ModalTools").modal("hide");
        alertMsg("success", this.translations.index.save_va_tools_success)
        this.virtualAssistant.tools = response.tools; //Atualiza a lista de ferramenats do VA

        //Exibir a lista de ferramentas
        $("#collapse_"+this.idx).attr('aria-expanded', 'true');
        $("#collapse_"+this.idx).attr('style', '');
        $("#collapse_"+this.idx).attr('class', 'collapse in');
      }else{
        alertMsg("error", this.translations.index.save_va_tools_error)
      }
    },

    //Enable or disable Virtual Assistant
    changeStatus: function(va) {
      this.processing = true;
      const url = `${this.base_url}/change-status/${this.encryption.encrypt(va.id, this.encryption_key)}`;
      axios
        .get(url)
        .then(response => this.changeListStatus(response.data.status, va))
    },

    //Update the list when status change
    changeListStatus: function(result, va) {
      if (!result) {
        alertMsg("error", this.translations.index.change_va_status_error);
      }
      this.reorder(this.reorder_key);
      this.processing = false;
    },

    openCreateModal: function(va) {
      if(!this.processing){
        this.virtualAssistant = null;
        this.va_name = "";
        $("#ModalSave").modal("show");
      }
    },

    //Save Virtual Assistant
    save: function(id = null) {
      $("#ModalSave").modal("hide");
      this.processing = true;
      if (this.isEmpty(this.va_name)) {
        alertMsg("error", this.translations.index.va_create_error_empty);
        this.processing = false;
      } else {
          if(id == null){ //NEW VA
            const url = `${this.base_url}/create`;
            let key = this.makeKey(32);
          axios
            .post(url, qs.stringify({ name: this.va_name, key: key }))
            .then(response => this.createResponse(response.data));

        }else{ //EDIT VA
          const url = `${this.base_url}/edit`;
          axios
            .post(url, { name: this.va_name, id: this.encryption.encrypt(this.virtualAssistant.id, this.encryption_key) })
            .then(response => this.editResponse(response.data.status));

        }
      }
    },

    //Deal with create VA response
    createResponse: function(data) {
      if (data.success && data.code == 0) {
        this.list.unshift(data.data);
        this.reorder(this.reorder_key);
        alertMsg("success", this.translations.index.va_create_success);
      } else {
        alertMsg("error", this.translations.index.va_create_error);
      }
      this.processing = false;
    },

    //Deal with create VA response
    editResponse: function(result) {
      if (result) {
        alertMsg("success", this.translations.index.va_edit_success);
        this.virtualAssistant.first_name = this.va_name;
        this.reorder(this.reorder_key);
      } else {
        alertMsg("error", this.translations.index.va_edit_error);
      }
      this.processing = false;
    },

    //Update the list when status change
    clipboard: function() {
        alertMsg("success", this.translations.index.copied);
    },

    //open the delete modal
    openDeleteModal: function(va, index) {
      if(!this.processing){
        $("#ModalDelete").modal("show");
        this.idx = index;
        this.virtualAssistant = va;
      }
    },

    //delete the va
    deleteVA: function() {
      $("#ModalDelete").modal("hide");
      this.processing = true;
      if (this.isEmpty(this.virtualAssistant)) {
        alertMsg("error", this.translations.index.ocorreu_erro);
        this.processing = false;
      } else {
        const url = `${this.base_url}/delete`;
        axios
          .post(url, { id: this.encryption.encrypt(this.virtualAssistant.id, this.encryption_key) })
          .then(response => this.deleteResponse(response.data.status, this.idx));
      }
    },

    //Deal with delete VA response
    deleteResponse: function(result, index) {
      if (result) {
        this.list.splice(index, 1);
        alertMsg("success", this.translations.index.success_delete_va);
      } else {
        alertMsg("error", this.translations.index.ocorreu_erro);
      }
        this.processing = false;
    },

    //open the delete modal
    openEditModal: function(va) {
      if(!this.processing){
        this.virtualAssistant = va;
        this.va_name = va.first_name;
        $("#ModalSave").modal("show");
      }
    },

    reorderSelectChange: function (event) {
      this.reorder_key = event.target.value;
      this.reorder(this.reorder_key);
    },

    reorder: function (key) {

      //ocultando todas listagens de ferramentas
      $(".in").each(function (index) {
         $(this).removeClass( "in" );
      });


      if(key == "name_asc"){
        this.list.sort(this.compareValues('first_name')); //ordem alfabética asc
      }else if(key == "name_desc"){
	      this.list.sort(this.compareValues('first_name', 'desc')); //ordem alfabética desc
      }else  if(key == "created_asc"){
        this.list.sort(this.compareValues('created_at')); //ordem cronológica
      }else if(key == "created_desc"){
	      this.list.sort(this.compareValues('created_at', 'desc')); //ordem cronológica desc
      }else  if(key == "status_asc"){
        this.list.sort(this.compareValues('is_active', 'desc')); //status false < true
      }else if(key == "status_desc"){
        this.list.sort(this.compareValues('is_active')); //status false > true
      }
    },
    //Generic methods

    //Verify if string is empty
    isEmpty: function(val) {
      return val === undefined || val == null || val.length <= 0 ? true : false;
    },

    //Genrate Key for VA
    makeKey: function(length) {
      var text = "";
      var possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789#$@!*";
      for (var i = 0; i < length; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      return text;
    },

// function for dynamic sorting
compareValues: function (key, order='asc') {
  return function(a, b) {
    if(!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    const varA = (typeof a[key] === 'string') ?
      a[key].toUpperCase() : a[key];
    const varB = (typeof b[key] === 'string') ?
      b[key].toUpperCase() : b[key];

    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return(
      (order == 'desc') ? (comparison * -1) : comparison
    );
  };
}


  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

$disabledRowColor: #e7e5e5;

  //Mobile
  @media only screen
    and (min-device-width : 320px)
    and (max-device-width : 480px){
    .title-page{
      font-size: 18pt !important;
    }
  }

.virtual__assistant__container {
  margin: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.title-page{
  font-size: 21pt;
  font-weight: 500;
  letter-spacing: 0px;
  margin: 0px;
  padding: 0px;
  font-family: Muli-Regular;
  box-sizing: border-box;
  line-height: 1.05;
  margin: 0 0 10px;
}

.show-hide{
    float: right;
    font-size: 10px;
}

.btn-copy{
    float: right;
    height: 25px;
    width: 50px;
    margin-right: 10px;
}

.now-hide{
  color: #999;
  text-decoration: line-through;
}

::selection {
    background: var(--theme-color-primary);;
    color: white;
}

.disabled {
  background-color: $disabledRowColor;
  text-decoration: line-through;

    &:hover{
    background-color: darken($disabledRowColor, 5%) !important;
  }
}
.btnAction, .copy {
  color: #999;
  padding: 10px;
  &:hover {
    color: var(--theme-color-primary);
  }
}

.tb_row{
    border-bottom: #cccccc solid 1.5px;

   &:hover{
    background-color: lighten($disabledRowColor, 5%);
  }
}

.copy{
  background-color: transparent;
  border: 0;
  padding: 0;
  margin-left: 5px;
}

.titleModal {
  font-size: 20px;
}

.btnCadastro {
  background-color: var(--theme-color-primary);
  color: #fff;
}
.btnBlueCreate {
  color: #fff;
  float: right;
  margin-bottom: 10px;
}

.btnFooter{
  margin-top: 10px;
}

.td-key{
  min-width: 400px;
}

.td-md{
  min-width: 200px;
}

.td-sm{
  min-width: 120px;
}

.edit-tools{
    margin-bottom: 8px;
}

.tools{
  .tier-1{
    color: var(--theme-color-primary);
  }

  .tier-2{
    margin-left: 15px;
  }

  .tier-3{
    margin-left: 40px;
  }
}

.action-icon{
  color: rgba(0, 0, 0, 0.50);
  vertical-align: middle;
   &:hover {
        opacity: .9;
        cursor: pointer;
    }
}

.disabled-icon{
  color: rgba(0, 0, 0, 0.30);
  vertical-align: middle;
}


/* Modal */
.modal-dialog-tools{
    overflow-y: initial !important
}
.modal-body-tools{
    height: 400px;
    overflow-y: auto;
    margin-left: 3%;
}


// Toggle
.toggle {
  cursor: pointer;
  display: inline-block;
}

.toggle-switch {
  display: inline-block;
  background: #ccc;
  border-radius: 16px;
  width: 58px;
  height: 32px;
  position: relative;
  vertical-align: middle;
  transition: background 0.25s;
}
.toggle-switch:before, .toggle-switch:after {
  content: "";
}
.toggle-switch:before {
  display: block;
  background: linear-gradient(to bottom, #fff 0%, #eee 100%);
  border-radius: 50%;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
  width: 24px;
  height: 24px;
  position: absolute;
  top: 4px;
  left: 4px;
  transition: left 0.25s;
}
.toggle:hover .toggle-switch:before {
  background: linear-gradient(to bottom, #fff 0%, #fff 100%);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
}
.toggle-checkbox:checked + .toggle-switch {
  background: var(--theme-color-primary);
}
.toggle-checkbox:checked + .toggle-switch:before {
  left: 30px;
}

.toggle-checkbox {
  position: absolute;
  visibility: hidden;
}

.toggle-label {
  margin-left: 5px;
  position: relative;
  top: 2px;
}


</style>



// WEBPACK FOOTER //
// resources/office/js/components/virtual-assistant/index.vue